/*! tp-trust.js — MuslimsReads Trust Page v1.0
   Reveal + accordion (with ARIA) + GA4 analytics (Dev Spec §2.2/§2.3) + video_play + lazy review widgets.
   Loaded with `defer` from sections/tp-trust.liquid. No copy, no layout logic. */
(function () {
  var scope = document.getElementById('tp');
  if (!scope) return;

  function ev(name, params) {
    if (window.gtag) { gtag('event', name, params || {}); }
    else { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params || {})); }
  }

  /* ---- reveal on scroll (honours prefers-reduced-motion via CSS) ---- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  scope.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });

  /* ---- accordion: open/close + max-height + aria-expanded + faq_open ---- */
  scope.querySelectorAll('.acc-q').forEach(function (b, i) {
    b.addEventListener('click', function () {
      var item = b.parentElement, a = b.nextElementSibling, open = item.classList.contains('open');
      if (open) {
        item.classList.remove('open'); a.style.maxHeight = null; b.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; b.setAttribute('aria-expanded', 'true');
        ev('faq_open', { faq_question: (b.textContent || '').replace(/\+$/, '').trim().slice(0, 90), faq_index: i });
      }
    });
  });

  /* ---- page view ---- */
  ev('trust_page_view', { page_path: location.pathname });

  /* ---- section_view (once each) + timeline_view ---- */
  var seen = {};
  var secIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        var id = e.target.id || e.target.className.split(' ')[0];
        if (!seen[id]) {
          seen[id] = 1; ev('section_view', { section_id: id });
          if (id === 'how') ev('timeline_view', { steps: 8 });
          secIO.unobserve(e.target);
        }
      }
    });
  }, { threshold: 0.4 });
  scope.querySelectorAll('section, .hero, .trustbar').forEach(function (s) { secIO.observe(s); });

  /* ---- scroll depth 25/50/75/100 ---- */
  var marks = [25, 50, 75, 100], hit = {}, maxp = 0;
  window.addEventListener('scroll', function () {
    var st = window.scrollY, h = document.body.scrollHeight - window.innerHeight;
    var p = h > 0 ? Math.round(st / h * 100) : 0; if (p > maxp) maxp = p;
    marks.forEach(function (m) { if (p >= m && !hit[m]) { hit[m] = 1; ev('scroll_depth', { percent: m }); } });
  }, { passive: true });

  /* ---- delegated data-ga clicks (skip <video>; handled below) ---- */
  scope.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ga]'); if (!a || a.tagName === 'VIDEO') return;
    ev(a.getAttribute('data-ga'), { source: a.getAttribute('data-ga-source') || undefined });
  });

  /* ---- verification video play ---- */
  scope.querySelectorAll('video[data-ga="video_play"]').forEach(function (v) {
    v.addEventListener('play', function () { ev('video_play', { which: 'verify' }); }, { once: true });
  });

  /* ---- exit ---- */
  window.addEventListener('pagehide', function () {
    var last = Object.keys(seen).pop(); ev('trust_exit', { last_section: last, max_scroll: maxp });
  });

  /* ---- lazy-init review widgets (~600px before #reviews; keeps them off first load) ----
     Judge.me is installed theme-wide, so only Trustpilot is lazy-loaded here; the .jdgm-all-reviews-widget div
     populates from the store's global Judge.me install. */
  var reviews = document.getElementById('reviews');
  if (reviews) {
    var loaded = false;
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && !loaded) {
          loaded = true;
          // Judge.me is installed theme-wide → the .jdgm-all-reviews-widget div populates from the global install (no lazy loader here).
          if (scope.querySelector('[data-lazy-widget="trustpilot"]')) {
            var ts = document.createElement('script'); ts.async = true;
            ts.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
            document.head.appendChild(ts);
          }
          rio.disconnect();
        }
      });
    }, { rootMargin: '600px 0px' });
    rio.observe(reviews);
  }
})();
